import LoginPage from './login';
import SignUpPage from './signup';
import ForgotPasswordPage from './forgot-password';
import ResetPasswordPage from './reset-password';

export { LoginPage, SignUpPage, ForgotPasswordPage, ResetPasswordPage };



// WEBPACK FOOTER //
// ./src/modules/onboarding/pages/index.js